export default __webpack_public_path__ + "static/media/header-logo-text.f4064776.svg";